import styled from 'styled-components';

import { colors } from 'shared/defaultTheme';

export const GroupOptionsConfigWrapper = styled.div`
  ul {
    color: ${colors.black};
  }
`;
